(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-header"]) return;
  try {
    
(() => {
  const STORAGE_KEY = 'bazzareo_recent_searches_v1';
  const maxItems = 8;

  const readItems = () => {
    try {
      const items = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(items) ? items.filter(Boolean).slice(0, maxItems) : [];
    } catch (e) {
      return [];
    }
  };

  const saveItems = (items) => {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(items.slice(0, maxItems)));
    } catch (e) {}
  };

  const getQuery = () => {
    try {
      return new URLSearchParams(window.location.search).get('q')?.trim() || '';
    } catch (e) {
      return '';
    }
  };

  const rememberCurrentSearch = () => {
    const query = getQuery();
    if (!query) return;
    const items = readItems().filter(item => item.toLowerCase() !== query.toLowerCase());
    items.unshift(query);
    saveItems(items);
  };

  const renderRecentSearches = () => {
    const list = document.querySelector('[data-bazzareo-recent-list]');
    const empty = document.querySelector('[data-bazzareo-recent-empty]');
    if (!list) return;

    const items = readItems();
    list.querySelectorAll('.bazzareo-recent-item').forEach(el => el.remove());

    if (!items.length) {
      if (empty) empty.hidden = false;
      return;
    }

    if (empty) empty.hidden = true;

    items.forEach((query) => {
      const link = document.createElement('a');
      link.className = 'bazzareo-recent-item';
      link.href = `/search?q=${encodeURIComponent(query)}`;
      link.innerHTML = `
        <span class="bazzareo-recent-icon">⌕</span>
        <span class="bazzareo-recent-text">${query.replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]))}</span>
      `;
      list.appendChild(link);
    });
  };

  const bind = () => {
    rememberCurrentSearch();
    renderRecentSearches();

    const page = document.querySelector('.bazzareo-search-page');
    const searchInput = document.querySelector('.bazzareo-search-input-wrap input[name="q"], .bazzareo-search-input-wrap input[type="search"]');
    const back = document.querySelector('.bazzareo-search-back');

    const openDiscovery = () => {
      if (!page) return;
      page.classList.add('bazzareo-search-focused');
      renderRecentSearches();
      if (searchInput) {
        setTimeout(() => searchInput.focus({ preventScroll: true }), 0);
      }
    };

    if (searchInput && !searchInput.dataset.bazzareoBound) {
      searchInput.dataset.bazzareoBound = 'true';
      searchInput.addEventListener('focus', openDiscovery);
      searchInput.addEventListener('click', openDiscovery);
    }

    if (back && !back.dataset.bazzareoBound) {
      back.dataset.bazzareoBound = 'true';
      back.addEventListener('click', (event) => {
        if (page && page.classList.contains('bazzareo-search-focused')) {
          event.preventDefault();
          page.classList.remove('bazzareo-search-focused');
          if (searchInput) searchInput.blur();
          return;
        }
      });
    }

    const clear = document.querySelector('[data-bazzareo-clear-searches]');
    if (clear && !clear.dataset.bound) {
      clear.dataset.bound = 'true';
      clear.addEventListener('click', () => {
        saveItems([]);
        renderRecentSearches();
      });
    }

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('form');
      if (!form) return;
      const input = form.querySelector('input[name="q"]');
      if (!input || !input.value.trim()) return;

      const query = input.value.trim();
      const items = readItems().filter(item => item.toLowerCase() !== query.toLowerCase());
      items.unshift(query);
      saveItems(items);
    }, { once: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();

  } catch(e) { console.error(e); }
})();
})();
